module.exports = __webpack_public_path__ + "media/topSection/1-2576e7fa.png";